import script from "./EducationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationBlock.vue?vue&type=script&setup=true&lang=js"

import "./EducationBlock.vue?vue&type=style&index=0&id=7fbf1266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbf1266"]])

export default __exports__